module.exports = __webpack_public_path__ + "img/SM.5fe08e47.svg";